module.exports = __webpack_public_path__ + "static/GMD-tablet-app-cover-14c2777d778a9fcac883e94ddcba7018.png";